/* eslint-disable camelcase */
import { DaoModel } from './daoModel';

export class ModelLanguage extends DaoModel {
  constructor(guid, name, countryCode, featureText, image) {
    super(guid);
    this.name = name;
    this.countryCode = countryCode;
    this.featureText = featureText;
    this.image = image;
  }

  static toInstance(props = {}) {
    return new ModelLanguage(props.guid, props.name, props.country_code, props.feature_text, props.image);
  }

  serialize() {
    return {
      ...super.serialize(),
      name: this.name,
      country_code: this.countryCode,
      feature_text: this.featureText,
      image: this.image,
    };
  }
}
